// export const API_PATH = "https://muzsaroy.bgsoft.uz/api/"
export const API_PATH = "https://muzsaroy.bgsoft.uz/api/"
// export const API_PATH = "https://devmuzsaroy.bgsoft.uz"

export const AUTH = {headers: {Authorization: "Bearer " + localStorage.getItem("alpToken")}}